import { Getters } from 'vuex-smart-module';
import CommercialOffersState from './state';

export default class CommercialOffersGetters extends Getters<CommercialOffersState> {
  get commercialProposalRequest() {
    return {
      ...this.state.new_offer,
      products: this.state.new_offer.products.map(({ file, ...product }) => product),
      users: this.state.new_offer.users.map(({ image, ...user }) => user),
    };
  }

  get commercialProposalFileUpdateRequest() {
    const formData = new FormData();

    this.state.new_offer.products
      .forEach((product, index) => {
        if (product.file) {
          formData.append(`products[${index}][is_partner_product]`, product.is_partner_product ? '1' : '0');
          formData.append(`products[${index}][product_id]`, product.product_id.toString());
          formData.append(`products[${index}][file]`, product.file);
        }
      });

    this.state.new_offer.users
      .forEach((user, index) => {
        if (user.user_id && user.image) {
          formData.append(`users[${index}][user_id]`, user.user_id.toString());
          formData.append(`users[${index}][image]`, user.image);
        }
      });

    return formData;
  }

  get hasCommercialProposalFiles() {
    return [...this.getters.commercialProposalFileUpdateRequest].length > 0;
  }
}
